/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestSetItem
 */
export interface RequestSetItem {
    /**
     * 実出荷単位数
     * @type {number}
     * @memberof RequestSetItem
     */
    actualShippingNum?: number;
    /**
     * 納品数
     * @type {number}
     * @memberof RequestSetItem
     */
    arriveCount: number;
    /**
     * 予定入荷総数
     * @type {number}
     * @memberof RequestSetItem
     */
    expectedCount: number;
    /**
     * 賞味期限（任意）
     * @type {string}
     * @memberof RequestSetItem
     */
    expiryDate?: string;
    /**
     * JANコード
     * @type {string}
     * @memberof RequestSetItem
     */
    jan: string;
    /**
     * 商品名
     * @type {string}
     * @memberof RequestSetItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RequestSetItem
     */
    place?: string;
    /**
     * セット数
     * @type {number}
     * @memberof RequestSetItem
     */
    setCount: number;
    /**
     * 
     * @type {number}
     * @memberof RequestSetItem
     */
    sumNum?: number;
}

/**
 * Check if a given object implements the RequestSetItem interface.
 */
export function instanceOfRequestSetItem(value: object): value is RequestSetItem {
    if (!('arriveCount' in value) || value['arriveCount'] === undefined) return false;
    if (!('expectedCount' in value) || value['expectedCount'] === undefined) return false;
    if (!('jan' in value) || value['jan'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('setCount' in value) || value['setCount'] === undefined) return false;
    return true;
}

export function RequestSetItemFromJSON(json: any): RequestSetItem {
    return RequestSetItemFromJSONTyped(json, false);
}

export function RequestSetItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestSetItem {
    if (json == null) {
        return json;
    }
    return {
        
        'actualShippingNum': json['actual_shipping_num'] == null ? undefined : json['actual_shipping_num'],
        'arriveCount': json['arrive_count'],
        'expectedCount': json['expected_count'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'jan': json['jan'],
        'name': json['name'],
        'place': json['place'] == null ? undefined : json['place'],
        'setCount': json['set_count'],
        'sumNum': json['sum_num'] == null ? undefined : json['sum_num'],
    };
}

export function RequestSetItemToJSON(json: any): RequestSetItem {
    return RequestSetItemToJSONTyped(json, false);
}

export function RequestSetItemToJSONTyped(value?: RequestSetItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_shipping_num': value['actualShippingNum'],
        'arrive_count': value['arriveCount'],
        'expected_count': value['expectedCount'],
        'expiry_date': value['expiryDate'],
        'jan': value['jan'],
        'name': value['name'],
        'place': value['place'],
        'set_count': value['setCount'],
        'sum_num': value['sumNum'],
    };
}

